// eslint-disable-next-line import/prefer-default-export
export enum AUTH_USER {
	AUTH_USER_LOAD_START = 'AUTH_USER_LOAD_START',
	AUTH_USER_LOAD_DONE = 'AUTH_USER_LOAD_DONE',
	AUTH_USER_LOAD_FAIL = 'AUTH_USER_LOAD_FAIL'
}
